// @ts-nocheck
// get all admins
export const FETCH_ALL_ADMIN_REQUEST = "FETCH_ALL_ADMIN_REQUEST";
export const FETCH_ALL_ADMIN_SUCCESS = "FETCH_ALL_ADMIN_SUCCESS";
export const FETCH_ALL_ADMIN_FAILURE = "FETCH_ALL_ADMIN_FAILURE";

// create an admin
export const CREATE_ADMIN_REQUEST = "CREATE_ADMIN_REQUEST";
export const CREATE_ADMIN_SUCCESS = "CREATE_ADMIN_SUCCESS";
export const CREATE_ADMIN_FAILURE = "CREATE_ADMIN_FAILURE";

// update an admin
export const UPDATE_ADMIN_REQUEST = "UPDATE_ADMIN_REQUEST";
export const UPDATE_ADMIN_SUCCESS = "UPDATE_ADMIN_SUCCESS";
export const UPDATE_ADMIN_FAILURE = "UPDATE_ADMIN_FAILURE";

// delete an admin
export const DELETE_ADMIN_REQUEST = "DELETE_ADMIN_REQUEST";
export const DELETE_ADMIN_SUCCESS = "DELETE_ADMIN_SUCCESS";
export const DELETE_ADMIN_FAILURE = "DELETE_ADMIN_FAILURE";

// search an admin
export const SEARCH_ADMIN_REQUEST = "SEARCH_ADMIN_REQUEST";
export const SEARCH_ADMIN_SUCCESS = "SEARCH_ADMIN_SUCCESS";
export const SEARCH_ADMIN_FAILURE = "SEARCH_ADMIN_FAILURE";

// toggle status of an admin
export const TOGGLE_ADMIN_STATUS_REQUEST = "TOGGLE_ADMIN_STATUS_REQUEST";
export const TOGGLE_ADMIN_STATUS_SUCCESS = "TOGGLE_ADMIN_STATUS_SUCCESS";
export const TOGGLE_ADMIN_STATUS_FAILURE = "TOGGLE_ADMIN_STATUS_FAILURE";